import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);


export const normalizeRawDate = (rawDate: any): string | null => {
  if (!rawDate) return null;
  if(dayjs(rawDate).isValid()) return dayjs(rawDate).format('DD/MM/YYYY');
  
  // Converte para string e remove espaços em branco
  let normalized = String(rawDate).trim();
  
  // Remove caracteres especiais desnecessários
  normalized = normalized.replace(/[^\d/\-\.]/g, '');
  
  // Remove espaços duplos ou múltiplos
  normalized = normalized.replace(/\s+/g, '');
  
  // Se está vazio após limpeza, retorna null
  if (!normalized) return null;
  
  // Normaliza separadores de data para /
  normalized = normalized.replace(/[-\.]/g, '/');
  
  // Remove barras duplas ou múltiplas
  normalized = normalized.replace(/\/+/g, '/');
  
  // Remove barras no início ou fim
  normalized = normalized.replace(/^\/|\/$/g, '');
  
  return normalized;
};


export const normalizeRawValue = (rawValue: any): string | null => {
  if (!rawValue) return null;
  
  // Converte para string e remove espaços em branco
  let normalized = String(rawValue).trim();
  
  // Remove espaços em qualquer lugar
  normalized = normalized.replace(/\s/g, '');
  
  // Remove caracteres que não são dígitos, vírgula, ponto, ou sinal de menos
  normalized = normalized.replace(/[^\d,\.-]/g, '');
  
  // Se está vazio após limpeza, retorna null
  if (!normalized) return null;
  
  // Normaliza separadores decimais
  // Se tem vírgula e ponto, assume que vírgula é decimal (padrão brasileiro)
  if (normalized.includes(',') && normalized.includes('.')) {
    // Remove pontos (milhares) e mantém vírgula (decimal)
    normalized = normalized.replace(/\./g, '').replace(',', '.');
  } else if (normalized.includes(',')) {
    // Só tem vírgula - assume que é decimal
    normalized = normalized.replace(',', '.');
  }
  
  // Remove pontos ou vírgulas múltiplas
  normalized = normalized.replace(/\.+/g, '.').replace(/,+/g, ',');
  
  return normalized;
};


export const parseNormalizedDate = (normalizedDate: string): Date | null => {
  if (!normalizedDate) return null;

  // Lista de formatos comuns para tentar
  const dateFormats = [
    'DD/MM/YYYY',
    'DD/MM/YY', 
    'YYYY/MM/DD',
    'MM/DD/YYYY',
    'MM/DD/YY',
    'DD-MM-YYYY',
    'DD-MM-YY',
    'YYYY-MM-DD',
    'MM-DD-YYYY',
    'MM-DD-YY',
    'DD/MM/YY', 
  ];

  // Tenta parsing com cada formato
  for (const format of dateFormats) {
    const parsed = dayjs(normalizedDate, format, true);
    if (parsed.isValid()) {
      return parsed.toDate();
    }
  }

  // Se nenhum formato funcionou, tenta parsing automático
  const autoParseDate = dayjs(normalizedDate);
  if (autoParseDate.isValid()) {
    return autoParseDate.toDate();
  }

  return null;
};


export const parseNormalizedValue = (normalizedValue: string): number | null => {
  if (!normalizedValue) return null;
  
  const parsed = parseFloat(normalizedValue);
  
  if (isNaN(parsed)) return null;
  
  return parsed;
};
